import generateParseObject from "./common/parse/ParseObjectFactory";
import {toJSONList,toJSON} from "./common/parse/helper/parse";
import * as  axios from "axios";

import  ReportService from "./Reports";

const ReportBoxObj = generateParseObject("v5_report_box");
const UserObj = generateParseObject('v5_user');
const ScoreItemTaskObj = generateParseObject('v5_score_item_task');
const DeviceDataObj = generateParseObject('v5_device_data');
const ExamObj = generateParseObject('v5_exam');
const Parse=window.Parse;
const getData = (resp) => resp.data;



export default class ReportBoxes {

    // 获取所有作业箱
    static async getAllReportBoxes(){
        // 获取助教中包含登录教师的的作业箱
        const query = new Parse.Query(ReportBoxObj);
        query.limit(9999);
        query.notEqualTo('isDeleted',true);
        query.descending("createdAt");
        return query.find().then(toJSONList).catch(e=>[]);
    }

    static getScoreItemTasks(boxId,score_item){
        const query = new Parse.Query(ScoreItemTaskObj);
        query.equalTo('boxId',boxId);
        query.equalTo('score_item',score_item);
        query.notEqualTo('isDeleted',true);
        return query.first().then(toJSON);
    }

    static getUserOthersStepReportBoxes(user,boxId){
        const query = new Parse.Query(ReportBoxObj);
        query.notEqualTo('isDeleted',true);
        query.notEqualTo('objectId',boxId);
        query.equalTo('reportType','step');
        query.equalTo('owner',user);
        query.descending("createdAt");
        query.limit(9999);
        return query.find().then(toJSONList).catch(e=>[]);
    }

    static getScoreItemTasksByBoxId(boxId){
        const query = new Parse.Query(ScoreItemTaskObj);
        query.equalTo('boxId',boxId);
        query.notEqualTo('isDeleted',true);
        return query.find().then(toJSONList);
    }
    // 获取教师的作业箱
    static async getReportBoxes(teacher){
        // 获取助教中包含登录教师的的作业箱
        const query = new Parse.Query(ReportBoxObj);
        query.limit(9999);
        query.equalTo('teachers',teacher);
        query.notEqualTo('isDeleted',true);
        query.descending("createdAt");
        return query.find().then(toJSONList).catch(e=>[]);
    }

    static async getReportBoxesInfo(teacher){
        const query = new Parse.Query(ReportBoxObj);
        query.limit(9999);
        query.equalTo('teachers',teacher);
        query.notEqualTo('isDeleted',true);
        query.select('name','_id');
        query.descending("createdAt");
        return query.find().then(toJSONList).catch(e=>[]);
    }

    static getUsersReportBoxes(user){
        const query = new Parse.Query(ReportBoxObj);
        if(user!=='all'){
            query.equalTo('teachers',user);
        }
        query.notEqualTo('isDeleted',true);
        query.descending("createdAt");
        query.limit(9999);
        return query.find().then(toJSONList).catch(e=>[]);
    }

    static statUsersUnArchivedReportBoxes(user){
        return axios.post("/teacher/report_box/user_unArchived_boxes", {user}).then(getData);
    }

    static statUsersArchivedReportBoxes(user){
        return axios.post("/teacher/report_box/user_archived_boxes", {user}).then(getData);
    }
    static getUsersUnArchivedReportBoxes(user){
        const  query = new Parse.Query(ReportBoxObj);
        query.equalTo('teachers',user);
        query.notEqualTo('isArchived',true);
        query.notEqualTo('isDeleted',true);
        query.descending("createdAt");
        query.limit(9999);
        return query.find().then(toJSONList).catch(e=>[]);
    }

    static getUsersArchivedReportBoxes(user){
        const  query = new Parse.Query(ReportBoxObj);
        query.equalTo('teachers',user);
        query.equalTo('isArchived',true);
        query.notEqualTo('isDeleted',true);
        query.descending("createdAt");
        query.limit(9999);
        return query.find().then(toJSONList).catch(e=>[]);    }

    static  getUserBoxTags(owner){
        const query = new Parse.Query(ReportBoxObj);
        query.equalTo('owner',owner);
        query.notEqualTo('isDeleted',true);
        query.select('tags');
        return query.find().then(toJSONList)
    }

    static addReportBox(name,reportType,score_types,tags,owner,teachers){
        // name:"作业1";
        // tags:"['课程1', '实验一']";
        // owner:"teacher1";
        // teachers:['teacher1']
        // allowJoin:true // 允许加入
        const addObj = {
            name,
            reportType,
            tags,
            owner,
            isOpen:true,
            teachers,
            allowJoin:true,
            score_types,
            students:[]
        };
        return axios.post("/teacher/report_box/add", addObj).then(getData);
    }

    static createReportBox(box){
        return axios.post("/teacher/report_box/create", box).then(getData);
        }

    static saveTaskInfo(boxId,score_item,tasks){
        return axios.post("/teacher/report_box/save_task_info", {boxId,score_item,tasks}).then(getData);
    }

    static getOrCreateScoreItemTasks(boxId,score_item){
        return axios.post("/student/report_box/get_or_create_score_item_tasks", {boxId,score_item}).then(getData);
    }

    static submitTask(reportId){
        return axios.post("/student/report_box/submit_task", {reportId}).then(getData);
    }

    static submitStepTask(taskId,tasks,index){
        return axios.post("/student/report_box/submit_step_task", {taskId,tasks,index}).then(getData);
    }

    static getStepTaskAiScore(taskId){
        return axios.post("/student/report_box/get_step_task_ai_score", {taskId}).then(getData);
    }
    
    static updateTask(key,value,taskId){
        return axios.post("/student/report_box/update_task", {key,value,taskId}).then(getData);
    }
    static startMeasure(deviceId,data,deviceSource){
        return axios.post("/student/report/start_measure", {deviceId,data,deviceSource}).then(getData);
    }

    static addReportBoxWithScoreItems(name,reportType,score_types,tags,owner,scoreItems,score_item_options,joinType){
        const addObj = {
            name,
            reportType,
            tags,
            owner,
            isOpen:true,
            teachers:[owner],
            allowJoin:true,
            score_types,
            students:[],
            scoreItems,
            score_item_options,
            joinType
        };
        return axios.post("/teacher/report_box/add_with_scoreItems", addObj).then(getData);
    }

    static addStepReportBoxWithScoreItems(name,reportType,score_types,tags,owner,scoreItems,score_item_options,boxId,joinType){
        const addObj = {
            name,
            reportType,
            tags,
            owner,
            isOpen:true,
            teachers:[owner],
            allowJoin:true,
            score_types,
            students:[],
            scoreItems,
            score_item_options,
            boxId,
            joinType
        };
        return axios.post("/teacher/report_box/add_step_box_with_scoreItems", addObj).then(getData);
    }

    static chaChong(reportId){
        return axios.get(`/chachong/report/${reportId}`).then(getData);
    }

    static get_similarity_batch(boxId){
        return axios.get(`/teacher/report_box/similarity_batch/${boxId}`).then(getData);
    }

    static get_chachong_result(boxId){
        return axios.get(`/chachong/chachong_result/${boxId}`).then(getData);
    }


    static startZipReports(boxId){
        return axios.post("/teacher/report_box/zip_reports", {boxId}).then(getData);
    }

    static getReportBox(id){
        return ReportBoxObj.getOne(id)
    }

    static updateReportBox(key,value,boxId){
        // type:"name";
        // value:"作业二";
        // boxId:"MDZAQLlqsO";
        return axios.post("/teacher/report_box/update", {key,value,boxId}).then(getData);
    }
    static archiveReportBox(boxId){
        return axios.post("/teacher/report_box/archive", {boxId}).then(getData);
    }

    static removeCourseReportBoxes(courseId){
        return axios.post("/teacher/report_box/remove_course_boxes", {courseId}).then(getData);
    }

    static quitReportBox(boxId){
        return axios.post("/student/report_box/quit", {boxId}).then(getData);

    }
    static joinReportBox(boxId){
        return axios.post("/student/report_box/join", {boxId}).then(getData);
    }

    static getStudentReportBoxes(student){
        const query = new Parse.Query(ReportBoxObj);
        query.equalTo('students',student);
        query.notEqualTo('isDeleted',true);
        // query.select('name','tags','isOpen');
        return query.find().then(toJSONList).catch(e=>[]);
    }

    static getAllowedReportBoxes(){
        const query = new Parse.Query(ReportBoxObj);
        query.equalTo('allowJoin',true);
        query.notEqualTo('isDeleted',true);
        return query.find().then(toJSONList)
    }

    // 上传文件
    static sendDataFile(file,fieldsMapping,boxId) {
        const formData = new FormData();
        formData.append('file',file);
        formData.append('fieldsMapping',fieldsMapping);
        formData.append('boxId',boxId);
        return axios({
            url:'/teacher/report_box/import_member/check_file',
            method:'post',
            data:formData
        }).then(getData)
    }

    static sendReportBoxDataFile(file,fieldsMapping) {
        const formData = new FormData();
        formData.append('file',file);
        formData.append('fieldsMapping',fieldsMapping);
        return axios({
            url:'/teacher/report_box/import_member/users',
            method:'post',
            data:formData
        }).then(getData)
    }

    // 确认导入
    static importFile(filePath,fieldsMapping,boxId) {
        return axios.post('/teacher/report_box/import_member/confirm_file',{filePath,fieldsMapping,boxId})
            .then(getData)
    }

    static async downloadZip(boxId) {
        const reports = await ReportService.getBackupedReportsByBoxId(boxId);
        const urls = reports.map(report=>report.backupUrl);
        const query = new Parse.Query(ReportBoxObj);
        const boxObj = await query.get(boxId);
        const boxName=boxObj.get("name");
        return axios.post('/teacher/report_box/mkzip_large', {urls, boxId, boxName})
            .then(getData).catch(e=>{return {status:false,message:"服务异常:"+e.message}})
    }

    // 获取助教信息
    static getAssistantInfo(username) {
        const query = new Parse.Query(UserObj);
        query.notEqualTo('isDeleted',true);
        query.equalTo('isTeacher',true);
        query.equalTo('username',username);
        return query.find().then(toJSONList)
    }

     // 获取助教信息
     static getStudentsById(id) {
        const query = new Parse.Query(ReportBoxObj);
        query.notEqualTo('isDeleted',true);
        query.equalTo('objectId',id);
        return query.first().then(toJSON)
    }

    static async getZipResult(boxId,persistentId) {
        return axios.post('/teacher/report_box/zip_result', {boxId,persistentId})
            .then(getData).catch(e=>{return {status:false,message:"服务异常:"+e.message}})
    }

    static async getHostZipResult(persistentId){
        return axios.post('/teacher/report_box/host_zip_result', {persistentId})
            .then(getData).catch(e=>{return {status:false,message:"服务异常:"+e.message}})
    }

    static startAIMarkBox(boxId,score_item){
        return axios.post("/teacher/report_box/ai_mark_all", {boxId,score_item}).then(getData);
    }

    static getBoxAIMarkResult(boxId,score_item){
        return axios.post("/teacher/report_box/box_ai_mark_result", {boxId,score_item}).then(getData);
    }




    static getOtherBoxes(boxId,user){
       const query = new Parse.Query(ReportBoxObj);
        query.notEqualTo('isDeleted',true);
        query.notEqualTo('objectId',boxId);
        query.equalTo('teachers',user);
        query.descending("createdAt");
        query.limit(9999);
        return query.find().then(toJSONList).catch(e=>[]);
    }

    static getLatestData(username,deviceId){
        const query = new Parse.Query(DeviceDataObj);
        query.equalTo('username',username);
        query.equalTo('emoocId',deviceId);
        query.descending("createdAt");
        return query.first().then(toJSON);
    }

    static getLatestImage(username,deviceId){
        return axios.post("/student/report/get_latest_image", {username,deviceId}).then(getData);
    }
    static getDeviceStatus(deviceId){
        return axios.get("/api/v1/emoocid/"+deviceId).then(getData);
    }

    static copyReportBox(boxId,teacher){
        return axios.post("/teacher/report_box/copy", {boxId,teacher}).then(getData);
    }

    static exportReport(taskId) {
        return axios.get("/api/v1/export_tasks/" + taskId, {
            responseType: 'blob', // 设置响应类型为 blob
        }).then(response => {
            // 返回响应的 blob 数据
            return response.data;
        });
    }

    //小测验相关
    static getRelatedExamByBoxId(boxId) {
        const query = new Parse.Query(ExamObj);
        query.containedIn("connectReportId", [boxId]);
        return query.find().then(results => results.map(toJSON));
    }

    static getBoxByXKKH(xkkh) {
        const query = new Parse.Query(ReportBoxObj);
        query.equalTo('XKKH', xkkh);
        query.notEqualTo('isDeleted', true);
        return query.first().then(toJSON);
    }

    static copyScoreItems(newBoxId,boxId,score_items){
        return axios.post("/teacher/report_box/copy_score_items", {newBoxId,boxId,score_items}).then(getData);
    }
}